import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';

ReactDOM.render(
  <App />
, document.getElementById('react-app'));



/** WEBPACK FOOTER **
 ** ./src/app.js
 **/